module.exports = __webpack_public_path__ + "lfbf_scan.5841e89416cb048ba03fdebc0c5020e1.svg";